module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LO6EWq/tc-custom/9783985310418.jpg",
      "alt": "This image is the cover for the book Why Authors Go Wrong, and Other Explanations, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Why Authors Go Wrong, and Other Explanations, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: \"It seems unlikely that any one will misunderstand the precise subject itself. What, exactly, is meant by an author “going wrong”? The familiar euphemism, as perhaps most frequently used, is anything but ambiguous. Ambiguous-sounding words are generally fraught with a deadly and specific meaning—another illustration of the eternal paradox of sound and sense. But as used in the instance of an author, “going wrong” has a great variety of meanings. An author has gone wrong, for example, when he has deliberately done work under his best; he has gone wrong when he has written for sentimental or æsthetic reasons and not, as he should, for money primarily; he has gone wrong when he tries to uplift or educate his readers; he has gone wrong when he has written too many books, or has not written enough books, or has written too fast or not fast enough, or has written what he saw and not what he felt, or what he felt and not what he saw, or posed in any fashion whatsoever.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Grant M. Overton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Journalist, literary critic, editor, and novelist. Worked for the New York Sun 1906-1908, 1910, editorial writer, 1916, and literary editor 1918-19. He worked for George H. Doran, book publisher, and was Editor of Colliers 1924-27. Author of at least ten books and editor of collections of short stories.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24980248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0